import { render, staticRenderFns } from "./OverwriteProduct.vue?vue&type=template&id=7c3fc2fa&"
import script from "./OverwriteProduct.vue?vue&type=script&lang=js&"
export * from "./OverwriteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports